import { render, staticRenderFns } from "./LogoutButton.vue?vue&type=template&id=763937ab&scoped=true&"
import script from "./LogoutButton.vue?vue&type=script&lang=js&"
export * from "./LogoutButton.vue?vue&type=script&lang=js&"
import style0 from "./LogoutButton.vue?vue&type=style&index=0&id=763937ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763937ab",
  null
  
)

export default component.exports